import React, { useEffect, useState } from 'react';
import DataTable from '../../components_shared/DataTable';
import { financeAPI } from '../../utils/api';
import Swal from 'sweetalert2';

export default function InvoicesPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await financeAPI.invoices.getAll();
      setRows(res.data.content || res.data);
    } catch (e) {
      Swal.fire({ icon: 'error', title: 'Error', text: e.message });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const columns = [
    { header: 'Ref #', accessorKey: 'referenceNo' },
    { header: 'Publisher', accessorKey: 'publisherName' },
    { header: 'WO #', accessorKey: 'workOrderNo' },
    { header: 'Qty', accessorKey: 'totalQty' },
    {
      header: 'Amount',
      accessorKey: 'amount',
      cell: info => new Intl.NumberFormat('en-US').format(info.getValue() || 0),
    },
    { header: 'Status', accessorKey: 'status' },
    { header: 'Created', accessorKey: 'createdAt' },
  ];

  return (
    <div>
      <h3 style={{ marginBottom: 12 }}>Invoices</h3>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <DataTable data={rows} columns={columns} />
      )}
    </div>
  );
}
